var _rect, _path, _circle, _circle2, _circle3, _rect2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 418,
    viewBox: "0 0 501 418",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 501,
    height: 417.822,
    rx: 32,
    fill: "#FFD392"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31C0 13.8792 13.8792 0 31 0H470C487.121 0 501 13.8792 501 31V86H0V31Z",
    fill: "#FFE4BB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 43.5,
    r: 8.5,
    fill: "#FFB600"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 43.5,
    r: 8.5,
    fill: "#FFB600"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 43.5,
    r: 8.5,
    fill: "#FFB600"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 123,
    width: 416,
    height: 256,
    rx: 22,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 159,
    x2: 136,
    y2: 159,
    stroke: "#FFD392",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 223,
    x2: 106,
    y2: 223,
    stroke: "#FFD392",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 261,
    x2: 106,
    y2: 261,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 299,
    x2: 106,
    y2: 299,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 337,
    x2: 106,
    y2: 337,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: 223,
    x2: 405,
    y2: 223,
    stroke: "#FFD392",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: 261,
    x2: 305,
    y2: 261,
    stroke: "#FFD392",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 312,
    y1: 159,
    x2: 322,
    y2: 159,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 159,
    x2: 374,
    y2: 159,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 159,
    x2: 426,
    y2: 159,
    stroke: "#FFE3BB",
    strokeWidth: 12,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 161,
    y: 295,
    width: 271,
    height: 64,
    rx: 12,
    fill: "url(#paint0_linear_1_241)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_241",
    x1: 156,
    y1: 327,
    x2: 432,
    y2: 327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE3BB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangew);
export default __webpack_public_path__ + "static/media/orangew.73c5177ca9eb428978a9979db91a9d09.svg";
export { ForwardRef as ReactComponent };